// @flow

import styled, { css } from "styled-components";
import Icon from "@fdr/static-ui/Icons/";
import { generateTransition, cubic } from "@fdr/static-ui/Transitions";
import buildColor from "@fdr/static-ui/ColorPalette";
import { fontCondensed, fontNormal } from "@fdr/static-ui/Typography";

export const StarIcon = styled(Icon)`
  position: absolute;
  top: -4px;
  right: -2px;
`;

export const SelectIcon = styled(Icon)`
  transform: ${(props) =>
    props.isRotated ? "rotate(180deg)" : "rotate(0deg)"};
  will-change: transform;
  transition: ${generateTransition(cubic, "transform")};
`;

export const RunnerNumberAtom = styled.span.attrs({
  "data-qa-label": "runnerNumber"
})`
  color: ${(props) => props.numberColor};
  position: relative;
  text-shadow: ${(props) => props.textShadow};
  background: ${(props) => props.gradient};
  border: ${(props) => props.border};
  border-radius: 1px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${(props) => props.saddleColor};
  flex-direction: ${(props) => props.flexDirection};
  ${({ isBigSize }) =>
    isBigSize
      ? css`
          font-size: 14px;
          font-family: ${fontCondensed};
          width: 20px;
          height: 20px;
        `
      : css`
          font-size: 12px;
          font-family: ${fontNormal};
          width: 16px;
          height: 16px;
        `};
  ${({ hasTimeformInfo }) =>
    hasTimeformInfo &&
    css`
      position: absolute;
      bottom: 0;
      right: 0;
      border: 1px solid ${buildColor("white", "100")};
      border-radius: 1px;
    `};
  ${({ isRightSpaced }) => isRightSpaced && "margin-right: 3px;"}
`;
